import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoResourceType } from '../interfaces/dto.resource.type.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoResourceType')
export class DtoResourceType extends ModelEntity implements IDtoResourceType {

    constructor(initValues: Partial<IDtoResourceType> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

}
